const translations = {
    date: 'Date',
    flightTime: 'Flight Time',
    flights: 'Flights',
    location: 'Location',
    pilot: 'Pilot'
};

export default translations;
